import { useMemo } from "react";

import { ArchitectureBase, Maybe } from "fond/types";

interface UseArchitectureSupportReturn {
  // The architecture has a demand model configured.
  hasDemandModel: boolean;

  // The architecture has BOM costs configured.
  hasBomCosts: boolean;
}

const hasDemandModel = (arch: ArchitectureBase): boolean => {
  return !!arch?.Demand?.DemandConfigurations?.length;
};

const hasBomCosts = (arch: ArchitectureBase): boolean => {
  if (!arch.BOM) return false;
  return arch.BOM.Categories.some((category) => category.Rows.some((row) => row.Cost > 0));
};

const useArchitectureSupport = (architecture: Maybe<ArchitectureBase>): UseArchitectureSupportReturn => {
  return useMemo(
    () => ({
      hasDemandModel: architecture ? hasDemandModel(architecture) : false,
      hasBomCosts: architecture ? hasBomCosts(architecture) : false,
    }),
    [architecture]
  );
};

export default useArchitectureSupport;
